import { getListData, accessAudit } from '@/api/T1/accessRegist'

export default {
  namespaced: true,
  mutations: {
    setgetListData: (state, payload) => { }
  },
  actions: {
    getListData(ctx, payload) {
      return getListData(payload).then((res) => {
        return res && res.status === 200 && res.data || {}
      })
    },
    accessAudit(ctx, payload) {
      return accessAudit(payload).then((res) => {
        if (res && res.status === 200) {
          return res
        }
      })
    }
  }
}
